import {
    IMPContextualNodeData, SlotPackage
} from '../../interface/DetailedBookingInterface';

interface CalculateImpressionsAndShareProps {
    nodeId: string,
    valueToLock: string,
    contextualNodes: IMPContextualNodeData[],
    selectedSlotPackage: string | null,
    slotPackagesData: SlotPackage[]
}

// calculations quip : https://quip-amazon.com/inMWAwYqYOBK/CalculationFormulas-in-Booking-Form
export const calculateImpressionsAndShare = ({
    nodeId,
    valueToLock,
    contextualNodes,
    selectedSlotPackage,
    slotPackagesData,
}: CalculateImpressionsAndShareProps): { impressions: number; share: number } => {
    const node = contextualNodes.find((n) => n.id === nodeId);
    if (
        !node?.imSegment ||
        !selectedSlotPackage ||
        !slotPackagesData.length ||
        !valueToLock
        || valueToLock.trim() === ''
    )
        return { impressions: 0, share: 0 };

    const selectedPackage = slotPackagesData.find(
        (pkg) => pkg.slotPackageName === selectedSlotPackage
    );

    if (!selectedPackage) return { impressions: 0, share: 0 };

    const selectedSegment = selectedPackage.segments.find(
        ({ segmentName }) => segmentName === node.imSegment
    );

    if (!selectedSegment || !selectedSegment.overAllImpressions || !selectedSegment.cpm)
        return { impressions: 0, share: 0 };

    const inputValue = parseFloat(valueToLock);
    if (isNaN(inputValue)) return { impressions: 0, share: 0 };

    const calculatedImpressions = Math.ceil((inputValue * 1000) / selectedSegment.cpm);
    const calculatedShare = Math.ceil((calculatedImpressions * 100) / selectedSegment.overAllImpressions);

    return {
        impressions: calculatedImpressions,
        share: calculatedShare
    };
};
